import PropTypes from 'prop-types';

const WeekDayCheckbox = ({ dayName, formikprops }) => (
  <span className="day-block">
    <input
      type="checkbox"
      name={`checkbox-option-${dayName}`}
      className="day-checkbox"
      id={dayName}
      onChange={(e) => {
        const { id, checked } = e.target;
        if (!checked) {
          formikprops.setFieldValue(
            'shiftDays',
            formikprops.values.shiftDays.filter((day) => day !== id)
          );
        } else {
          formikprops.setFieldValue('shiftDays', [
            ...formikprops.values.shiftDays,
            id,
          ]);
        }
      }}
      checked={formikprops.values.shiftDays.includes(dayName)}
    />
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label htmlFor={dayName} className="text-capitalize">
      {dayName.slice(0, 2)}
    </label>
  </span>
);

WeekDayCheckbox.propTypes = {
  dayName: PropTypes.string,
  formikprops: PropTypes.any,
};

export default WeekDayCheckbox;
